import PinyinMatch from "pinyin-match";
import { PagerParams } from "./utils";
import BaseService from "./BaseService";
import cookies from "js-cookie";
import { FocusSDK } from "@/utils";
import { labelInfoList } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { PRIORITY_TYPE, TASK_STATUS } from "@/types/newWork";
import { SubInfo } from "@/types/sub";

interface Highlight {
  name: string;
  value: string;
  key: string;
}

export interface SearchSubPage extends SearchCommon {
  ownerDepartmentName?: string;
  link?: string;
  shareAuth: number;
  ownerDepartmentId?: string;
  title: string;
  type?: number;
  content: string;
  pageStatus: number;
  appId: string;
  pageType: number;
  enableCancelFollow?: number;
  readAuth: number;
  summary: string;
  brief?: string;
  headImg?: string;
  author: string;
  avatar: string;
  pageId?: string;
  ownerFullPath?: string;
  subId: string;
  pushCode?: string;
  createTime: number;
  subName?: string;
  teamId?: string;
  activate?: string;
  createUser?: string;
  enableOtherFollow?: number;
}
interface SearchCommon {
  highlight: Highlight[];
}
export interface JoySpaceInfo {
  fullPathIds: string; // id$@$id
  fullPathNames: string; // $@$
  highlight: Highlight[];
  id: string;
  originId: string;
  pageId: string;
  pageType: string;
  previewText: string;
  spaceCategoryId: string;
  spaceId: string;
  spaceName: string;
  status: string;
  teamId: string;
  teamName: string;
  tenantId: string;
  title: string;
  type: string;
  icon_url?: string;
  content?: string;
}

export interface ContactInfo {
  app: string;
  userId: string;
  teamId: string;
  emplAccount: string;
  realName: string;
  mobile: string;
  email: string;
  avatar: string;
  deptName: string;
  ebookTag?: string;
  highlight: Highlight[];
  titleName?: string;
  labelInfoList?: labelInfoList[];
  unitName: string;
  remark: any;
}

export interface DeptInfo {
  code: string;
  message?: string;
  data: DepartmentList[];
}

export interface DepartmentList {
  childDept: [];
  deptCategory: string;
  deptId: string;
  deptName: string;
  deptProperty: string;
  fullName: string;
  fullPath: string;
  highlight: Highlight[];
  isParent: boolean;
  parentId: string;
  sortNum: number;
  nodeType?: string;
  teamId: string;
  realFullName: string;
}

export interface GroupInfo {
  groupId: string;
  groupName: string;
  groupType: string;
  avatar: string;
  highlight: Highlight[];
  groupUserCount: number;
  kind?: number;
  subKind?: number;
}

export interface TaskInfo {
  app: string;
  completeTime: number | null;
  content: string;
  endTime: number | null;
  highlight: Highlight[];
  highlight2: Highlight[];
  priorityType: PRIORITY_TYPE;
  startTime: number;
  status: number;
  taskId: string;
  taskStatus: number;
  teamId: string;
  title: string;
  userId: string;
  userInfo: any;
}

export interface AppInfo {
  appId: string;
  appName: string;
  brief: string;
  description: string;
  keyword: string;
  avatar: string;
  highlight: Highlight[];
  foreignLanguage: {
    lang: string;
    appName: string;
    avatar: string;
    brief: string;
    description: string;
    keyword: string;
  }[];
  ext: {
    androidWebviewKernel: number;
    applicationKey: string;
    developmentType: number;
    iosWebviewKernel: number;
    maxVersion: string;
    minVersion: string;
    mobileHomeUrl: string;
    padosWebviewKernel: number;
    pcHomeUrl: string;
    adminHomeUrl: string;
    trustedDomains: string;
    trustedIp: string;
    createType: number;
    applicationStatus: number;
    canDisable: number;
    favorite?: number;
    builder: string;
    developer: string;
  };
}

export interface SearchWorkTypes {
  taskStatus?: number[];
  beginTime?: string;
  endTime?: string;
  priorityType?: number[];
  color?: string[];
}
export interface SearchGlobalParams {
  keyword: string;
  searchType: SearchType;
  pageNo: number;
  pageSize: number;
  category?: number;
  classification?: number[];
  timeRange?: number;
  bizDocInfo?: SearchTypes;
  bizWorkInfo?: SearchWorkTypes;
}
export interface SearchTypes {
  folderIds?: string[];
  types?: string[];
}
export interface ScheduleInfo {
  agent: any;
  beginTime: any;
  calendarId: string;
  calendarType: string;
  canceled: string;
  canceledScheduleId: string;
  color: string;
  content: string;
  ddAppId: string;
  description: string;
  endTime: any;
  highlight: Highlight[];
  ownerTeamId: string;
  ownerUserId: string;
  repeat: number;
  scheduleId: string;
  teamId: string;
  title: string;
  userId: string;
}
export interface SearchGlobalRes {
  contacts?: ContactInfo[];
  groups?: GroupInfo[];
  apps?: AppInfo[];
  pages?: JoySpaceInfo[];
  subs?: SearchSubPage[];
  subPages?: SearchSubPage[];
  schedules?: ScheduleInfo[];
  works?: {
    [key: string]: TaskInfo[];
  }[];
  depts?: DeptInfo;
  hasMoreSubs?: boolean;
  hasMoreDepts?: Boolean;
  hasMoreGroups?: Boolean;
  hasMoreContacts?: Boolean;
  hasMoreApps?: Boolean;
}

export enum SearchType {
  All = "0",
  Contacts = "1",
  Group = "2",
  App = "3",
  JoySpace = "4",
  Task = "5",
  Schedule = "6",
  Department = "7",
  MessageHistory = "-1",
  Device = "8",
  Sub = "9"
}

class SearchService extends BaseService {
  /**
   * todo 外部联系人很多时会有性能问题
   * 目前调用了查询外部联系人接口，和用户详细信息，实现查询个部联系人功能
   * 搜索外部联系人
   * @param keyword
   */
  // async searchExternalContacts(keyword: string): Promise<any> {
  //     try {
  //         const content = await this.fetch<any>('efriend', 'getFriendsByGroup', {});
  //         const contacts = (content.groups || [])
  //             .reduce((result: any, item: any) => {
  //                 return result.concat(item.friends);
  //             }, [] as any)
  //             .map((item: any) => {
  //                 return {
  //                     appId: item?.app,
  //                     userId: item?.pin,
  //                     teamId: item?.teamId,
  //                 };
  //             });
  //         if (!contacts || contacts.length === 0) {
  //             return [];
  //         }

  //         const ebookUsers = await this.fetch<any>('ebook', 'getUserEbookDetailList', {
  //             ebookUserDetailReqList: contacts,
  //         });

  //         if (!ebookUsers || ebookUsers.length === 0) {
  //             return [];
  //         }

  //         return ebookUsers.reduce((resultSet: any, item: any) => {
  //             const name = item.fields.find((field: any) => field.key === 'name').val;
  //             const matched = PinyinMatch.match(name || '', keyword);
  //             if (matched) {
  //                 resultSet.push({
  //                     app: item.appId,
  //                     deptName: item.fields.find((field: any) => field.key === 'station').val,
  //                     avatar: item.fields.find((field: any) => field.key === 'avatar').val,
  //                     userId: item.userId,
  //                     realName: name,
  //                     teamId: item.teamId,
  //                     highlight: [
  //                         {
  //                             name: 'realName',
  //                             value: name,
  //                             key: Array.isArray(matched)
  //                                 ? name.slice(matched[0], matched[1] + 1)
  //                                 : keyword,
  //                         },
  //                     ],
  //                 });
  //             }
  //             return resultSet;
  //         }, [] as any);
  //     } catch (e) {
  //         return [];
  //     }
  // }

  searchGlobal(
    params: {
      keyword: string;
      searchType: any;
      folderIds?: string[]; // 文件夹id列表
      types?: string[]; // 文件类型列表
    } & PagerParams
  ) {
    if (
      params?.searchType === SearchType.App &&
      !(window as any)?._BTS_CONFIG?.REACT_APP_NOT_USE_ROBOT
    ) {
      params.searchType = "3, 8";
    }
    return this.fetch<SearchGlobalRes>("search", "searchGlobal", {
      appKey:
        FocusSDK.authInfo?.ddAppId ||
        cookies.get("focus-app-id") ||
        (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID ||
        process.env.REACT_APP_DD_APPID ||
        "",
      indexName: "global",
      ...params
    });
  }
}

export default SearchService;
